import type { KeycloakState, Page } from '@subaio/utils'

import type { Container } from 'lib/container'

export const getContainer = (
	containers: Record<string, Container>,
	page: Page | null,
	developerAuth: KeycloakState,
) => {
	const name = page?.name ?? ''
	const container = containers[name] ?? containers.NotFound

	switch (container.authentication.type) {
		case 'developer': {
			if (developerAuth.status === 'unauthenticated') {
				return containers.NotAuthenticatedDeveloper
			}
			if (
				developerAuth.status === 'authenticated' &&
				container.authentication.roles.some((role) => !developerAuth.user?.roles.includes(role))
			) {
				return containers.NotAuthorizedDeveloper
			}
			return container
		}
		case 'public':
		default:
			return container
	}
}
